import { render, staticRenderFns } from "./onboard.vue?vue&type=template&id=171ec242"
import script from "./onboard.vue?vue&type=script&lang=js"
export * from "./onboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports